const HaberKategori = resolve => {
    require.ensure(['../views/apps/haberkategori/HaberKategori'], () => {
        resolve(require('../views/apps/haberkategori/HaberKategori'))
    })
};
const HaberKategoriDetay = resolve => {
    require.ensure(['../views/apps/haberkategori/HaberKategoriDetay'], () => {
        resolve(require('../views/apps/haberkategori/HaberKategoriDetay'))
    })
};

import Vue from 'vue'
Vue.component('BultenDetay', HaberKategoriDetay);
import layouts from '../layout'

export default {
    path: '/haberkategori',
    name: 'haberkategori',
    component: HaberKategori,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'haberkategoridetay',
            component: HaberKategoriDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
